<div class="row">
  <div class="col-md-12">
    <fui-heading text="Fender Communications" [level]="5"></fui-heading>
    {{ "email_prefs.manage_how_you_hear" | translate }}
    <br />
    <br />
    @if (user.country != "US") {
      <h3 class="fui-heading-font t-20">{{ "email_prefs.fender_news_intl" | translate }}</h3>
      <myp-switch
        [active]="fenderEmailSettings.fender_news_intl"
        [label]="'email_prefs.fender_news_intl_description' | translate"
        [labelToRight]="true"
        (toggle)="fenderEmailSettings.fender_news_intl = !fenderEmailSettings.fender_news_intl"
      ></myp-switch>
    }
    @if (user.country == "US") {
      <h3 class="fui-heading-font t-20">{{ "email_prefs.fender_news" | translate }}</h3>
      <myp-switch
        [active]="fenderEmailSettings.fender_news"
        [label]="'email_prefs.fender_news_description' | translate"
        [labelToRight]="true"
        (toggle)="fenderEmailSettings.fender_news = !fenderEmailSettings.fender_news"
      ></myp-switch>
    }
    <h3 class="fui-heading-font m-t-30 t-20">{{ "email_prefs.fender_studio_news" | translate }}</h3>
    <myp-switch
      [active]="fenderEmailSettings.fender_studio_news"
      [label]="'email_prefs.fender_studio_news_description' | translate"
      [labelToRight]="true"
      (toggle)="fenderEmailSettings.fender_studio_news = !fenderEmailSettings.fender_studio_news"
    ></myp-switch>
    <h3 class="fui-heading-font m-t-30 t-20">{{ "email_prefs.presonus_news" | translate }}</h3>
    <myp-switch
      [active]="fenderEmailSettings.presonus_news"
      [label]="'email_prefs.presonus_news_description' | translate"
      [labelToRight]="true"
      (toggle)="fenderEmailSettings.presonus_news = !fenderEmailSettings.presonus_news"
    ></myp-switch>
    <br />
    <br />

    <button class="btn btn-secondary m-b-20" (click)="saveIterablePreferences()">
      <fa-icon icon="check"></fa-icon>
      &nbsp;{{ saveButtonText }}
    </button>
  </div>
</div>
@if (resubscribeImgSrc) {
  <img [src]="resubscribeImgSrc" width="0" height="0" />
}
